import React from "react";
import Logo from "../../Assets/T&T_Logo.png";
import Form from "./Form.jsx";
// import ClaimForm from "../ClaimForm/ClaimForm.jsx";
import Footer from "./Footer.jsx";
import { Link } from "react-router-dom";

function TrackAndTrail() {
  return (
    <section>
      <div className="bg-[#f1f2ee] w-full h-full">
        {/* Navigation Bar */}
        <nav className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8 h-20 flex items-start">
          <div className="flex w-full items-center justify-between">
            {/* Logo */}
            <img
              src={Logo}
              alt="Track and Trail logo"
              onClick={() =>
                window.open("https://www.trackandtrail.in/", "_blank")
              }
            />

            {/* Menu Icon */}
            <div>
              <ul>
                <li>
                  <Link to="/claim" className="text-black font-medium">
                    Warranty Claim
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Placeholder for Form */}
        <Form />
        {/* <ClaimForm /> */}

        {/* Footer */}
        <Footer />
      </div>
    </section>
  );
}

export default TrackAndTrail;
